import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue";
const _hoisted_1 = {
  class: "text-center"
};
const _hoisted_2 = {
  key: 0,
  class: "px-6 border-b pb-4 text-xl mb-4"
};
const _hoisted_3 = {
  key: 1,
  class: "flex items-center justify-center text-2xl py-4"
};
const _hoisted_4 = {
  key: 2,
  class: "text-green-500 font-bold text-3xl"
};
import ActionScreen from "@/modules/action-screens/components/ActionScreen.vue";
import { PromotionIconEnum } from "@/modules/competitions/enums";
import Flag from "@/modules/vue/components/Flag.vue";
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'LeaguePromotionActionScreen',
  props: {
    team: null,
    from: null,
    to: null,
    promotion: null,
    stats: null
  },
  emits: ['finished'],
  setup(__props) {
    const props = __props;
    const iconMap = {
      [PromotionIconEnum.UP]: IconEnum.AngleUp,
      [PromotionIconEnum.DOWN]: IconEnum.AngleDown,
      [PromotionIconEnum.TROPHY]: IconEnum.Crown,
      [PromotionIconEnum.CUP]: IconEnum.Trophy24Regular,
      [PromotionIconEnum.REMAIN]: IconEnum.DotCircleRegular
    };
    const colorMap = {
      [PromotionIconEnum.UP]: 'text-green-500',
      [PromotionIconEnum.DOWN]: 'text-red-500',
      [PromotionIconEnum.TROPHY]: 'text-green-500',
      [PromotionIconEnum.CUP]: 'text-lime-500',
      [PromotionIconEnum.REMAIN]: 'text-slate-500'
    };
    const icon = computed(() => props.promotion.icon ? iconMap[props.promotion.icon] : undefined);
    const colorClasses = computed(() => props.promotion.icon ? colorMap[props.promotion.icon] : undefined);
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(ActionScreen, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(__props.team.name), 1)]),
        subTitle: _withCtx(() => [__props.from.competition.country ? (_openBlock(), _createBlock(Flag, {
          key: 0,
          country: __props.from.competition.country
        }, null, 8, ["country"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(__props.from.competition.name), 1)]),
        controls: _withCtx(() => [_createVNode(_component_NButton, {
          secondary: "",
          type: "success",
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('finished'))
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('ok')), 1)]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [__props.stats ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", {
          class: _normalizeClass(["text-2xl font-bold", _unref(colorClasses)])
        }, _toDisplayString(_ctx.$t('x_rank', {
          rank: __props.stats.rank
        })), 3), _createTextVNode(" " + _toDisplayString(__props.from.name), 1)])) : _createCommentVNode("", true), !__props.to || __props.to.id !== __props.from.id ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_unref(icon) ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          icon: _unref(icon),
          class: _normalizeClass(["mr-4", _unref(colorClasses)])
        }, null, 8, ["icon", "class"])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(__props.to ? __props.to.name : __props.from.name), 1)])) : _createCommentVNode("", true), __props.promotion.price ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$money(__props.promotion.price)), 1)) : _createCommentVNode("", true)])]),
        _: 1
      }, 16);
    };
  }
});